import { arrayToMap } from "../util";

const list = [
  {
    name: "駐車場有",
    slug: "parking",
  },
  {
    name: "エレベーター有",
    slug: "elevator",
  },
  {
    name: "空調有", 
    slug: "aircon",
  },
  {
    name: "駅近物件", 
    slug: "access",
  },
];

export const data = {
  list: list,
  bySlug: arrayToMap(list, "slug"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/facility.js